import React from "react";
import LaunchCard from "../common/LaunchCard";
import Header from "../layouts/Header";

const steps = [
  {
    title: "Set Up Your Wallet",
    details: [
      {
        subtitle: "Install and Setup MetaMask",
        text: "Download MetaMask, create a new wallet or import an existing one, and securely back up your seed phrase."
      },
      {
        subtitle: "Fund Your Wallet",
        text: "Add funds (ETH, USDT, or BNB) to your wallet by transferring from another wallet or buying with a card."
      }
    ]
  },
  {
    title: "Connect Wallet & Buy OFNT",
    details: [
      {
        subtitle: "Connect Wallet",
        text: "Click 'Connect Wallet' at the top right and follow the prompts to link your wallet."
      },
      {
        subtitle: "Participate in Presale",
        text: "Enter the amount of OFNT you wish to buy and confirm the transaction. Wait for blockchain confirmation."
      }
    ]
  },
  {
    title: "Hold & Earn Rewards",
    details: [
      {
        text: "Hold your OFNT tokens in your wallet to earn daily rewards and participate in the OFNT ecosystem."
      }
    ]
  },
  {
    title: "Stay Secure",
    details: [
      {
        text: "Always verify you are on the official OFNT website and interacting with the correct smart contracts."
      }
    ]
  },
  {
    title: "Mind Transaction Fees",
    details: [
      {
        text: "Be aware of network fees for transactions on Ethereum, USDT, and BNB."
      }
    ]
  }
];

const accent = "#27c97a";
const cardBg = "#181c24";
const pageBg = "#10131a";
const textColor = "#e6eaf3";
const subtitleColor = accent;
const shadow = "0 2px 16px rgba(0,0,0,0.5)";

const HowToBuy = () => {
  return (
    <div style={{ background: pageBg, minHeight: "100vh" }}>
      <Header />
      <section style={{ padding: "48px 0" }}>
        <div className="container">
          <h1 style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "2.5rem",
            marginBottom: "2.5rem",
            color: textColor,
            letterSpacing: "0.01em"
          }}>
            How it Works
          </h1>
          <div style={{
            maxWidth: 800,
            margin: "0 auto"
          }}>
            {steps.map((step, idx) => (
              <div
                key={idx}
                style={{
                  background: cardBg,
                  borderRadius: 16,
                  boxShadow: shadow,
                  padding: "2rem 1.5rem 1.5rem 1.5rem",
                  marginBottom: "2rem",
                  position: "relative",
                  display: "flex",
                  alignItems: "flex-start",
                  border: `1px solid #23283a`
                }}
              >
                <div style={{
                  minWidth: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: accent,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: "1.5rem",
                  boxShadow: "0 2px 8px rgba(39,201,122,0.15)",
                  marginRight: 24,
                  marginTop: 4
                }}>
                  {idx + 1}
                </div>
                <div>
                  <h3 style={{
                    margin: 0,
                    fontSize: "1.35rem",
                    fontWeight: 600,
                    color: textColor
                  }}>{step.title}</h3>
                  <ul style={{ margin: "1rem 0 0 0", padding: 0, listStyle: "none" }}>
                    {step.details.map((detail, dIdx) => (
                      <li key={dIdx} style={{ marginBottom: "0.75rem" }}>
                        {detail.subtitle && (
                          <div style={{ fontWeight: 500, color: subtitleColor }}>{detail.subtitle}</div>
                        )}
                        <div style={{ color: "#bfc8e6", fontSize: "1rem" }}>{detail.text}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowToBuy;
